import logo from "./logo.svg";
import "./App.css";
import "./Components/style.css";
import Main from "./Components/Main";
import Header from "./Components/Header";

function App() {
  return (
    <>
      <Header />
      <Main />
    </>
  );
}

export default App;
